import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';
import { Leaf, Droplets, Users, Map } from 'lucide-react';
export function RainforestSection() {
  const {
    t
  } = useLanguage();
  const icons = [Map, Droplets, Leaf, Users];
  return <section id="rainforest" className="relative py-32 overflow-hidden" data-id="element-210">
      {/* Background Image */}
      <div className="absolute inset-0" data-id="element-211">
        <img src="https://cdn.magicpatterns.com/uploads/jhKK9myYZM2ukE7XPtF2Fs/ChatGPT_Image_15_jun_2026,_04_52_51_p.m..png" alt="Group enjoying a hidden waterfall in El Yunque" className="w-full h-full object-cover object-center" data-id="element-212" />
        <div className="absolute inset-0 bg-gradient-to-r from-rainforest-dark/90 via-rainforest-dark/70 to-transparent" data-id="element-213" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-214">
        <div className="max-w-2xl text-white" data-id="element-215">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="mb-8" data-id="element-216">
            <img src="https://cdn.magicpatterns.com/uploads/fDWRYDuPXFdmht4Kx9GQ1Z/ChatGPT_Image_15_jun_2026,_04_07_55_p.m..png" alt="Sweet and Salty Puerto Rico Adventures" className="h-40 w-40 md:h-48 md:w-48 object-cover rounded-3xl ring-2 ring-white/30 shadow-2xl" data-id="element-217" />
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-heading font-bold mb-6" data-id="element-218">
            {t.rainforestSection.title}
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-sand-light/90 mb-12 leading-relaxed" data-id="element-219">
            {t.rainforestSection.description}
          </motion.p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-12" data-id="element-220">
            {t.rainforestSection.features.map((feature, idx) => {
            const Icon = icons[idx];
            return <motion.div key={idx} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2 + idx * 0.1
            }} className="glass-panel p-6 rounded-2xl" data-id="element-221">
                  <Icon className="w-8 h-8 text-sand mb-4" data-id="element-222" />
                  <h4 className="font-bold text-xl mb-2" data-id="element-223">{feature.title}</h4>
                  <p className="text-sm text-sand-light/80" data-id="element-224">{feature.desc}</p>
                </motion.div>;
          })}
          </div>

          <motion.a initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} href="https://wa.link/ip0tbk" target="_blank" rel="noreferrer" className="inline-block bg-white text-rainforest-dark font-bold px-8 py-4 rounded-full hover:bg-sand transition-colors shadow-xl" data-id="element-225">
            {t.rainforestSection.cta}
          </motion.a>
        </div>
      </div>
    </section>;
}